import { render, staticRenderFns } from "./SaleConditions.vue?vue&type=template&id=487dbf21&"
import script from "./SaleConditions.vue?vue&type=script&lang=js&"
export * from "./SaleConditions.vue?vue&type=script&lang=js&"
import style0 from "./SaleConditions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports